import { takeLatest, put } from 'redux-saga/effects';
import { completeAuction, setChannelWorkflowLoadingOverlayState, appNotify } from 'store/actions';
import { putWithToken } from 'api/network';

export function* completeAuctionSaga() {
    yield takeLatest(completeAuction, function* ({ payload: auctionId }) {
        try {
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Completing auction...' }));
            yield putWithToken(`/api/underwrite/auction/${auctionId}/complete`, null);
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
            yield put(appNotify('Auction Completed!', 'success'));
        }
        catch (error) {
            yield put(appNotify(error.message, 'error'));
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
        }
    });
}